import {makeStyles} from "@mui/styles";
import {Theme} from "@mui/material";

export const useStyles: (theme: Theme) => {
  search_container: CSSStyleSheet,
  search_bar_container: CSSStyleSheet,
  filter_options_container: CSSStyleSheet,
  hubspot_filter_options: CSSStyleSheet,
  filterBox: CSSStyleSheet,
  pac_input_wrapper: CSSStyleSheet,
  filter_container: CSSStyleSheet,
  formControl: CSSStyleSheet,
  approvalContainer: CSSStyleSheet,
  infoIcon: CSSStyleSheet,
} = makeStyles(theme => ({
  search_container: {
    width: "100%",
    boxShadow: "0em 0.14em 0.07em -0.07em rgba(0, 0, 0, 0.2), 0em 0.07em 0.07em rgba(0, 0, 0, 0.14), 0em 0.14em 0.21em rgba(0, 0, 0, 0.12)",
    flexDirection: 'column',
  },
  search_bar_container: {
    borderRight: "0.07em solid #E0E0E0",
    boxShadow: theme.showPac ? "0px 4px 4px rgba(0, 0, 0, 0.25);" : "none",
    width: "100%",
    '@media (max-width:91.24em)': {
      borderRight: "none",
    },
  },
  filter_options_container: {
    flexDirection: 'row',
    backgroundColor: '#FBFBFF',
    flex: 1,
    gap: '1.8em',
    justifyContent: 'space-evenly',
    padding: '0em 1em',
  },
  hubspot_filter_options: {
    justifyContent: 'flex-start'
  },
  filterBox: {
    width: 'fit-content',
    alignItems: 'center'
  },
  pac_input_wrapper: {
    margin: "1em",
    width: "100%",
  },
  filter_container: {
    alignItems:'center', 
    justifyContent:'space-between'
  },
  approvalContainer: {
    marginLeft: '0.5em'
  },
  formControl: {
    fontSize: '0.5em'
  },
  infoIcon: {
    marginLeft: '-0.5em'
  }
}));